import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ModalHeaderProps {
    handleClose: () => void;
    title?: React.ReactNode;
}

export const ModalHeader = (props: ModalHeaderProps) => {
    return (
        <div className='flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200'>
            <h3 className='text-xl font-semibold text-gray-900 dark:text-white'>{props.title}</h3>
            <button
                id='close-button'
                onClick={props.handleClose}
                type='button'
                className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white'>
                <svg
                    className='w-3 h-3'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 14 14'>
                    <path
                        stroke='currentColor'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                        stroke-width='2'
                        d='m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6'
                    />
                </svg>
                <span className='sr-only'>
                    <FormattedMessage
                        id='modal-header-component.close'
                        defaultMessage='Close modal'
                        description='Message in button to close modal'
                    />
                </span>
            </button>
        </div>
    );
};
